import * as XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';
import JsonHelper from './JsonHelper';
import ArrayHelper from './ArrayHelper';

class ProductHelper {
    static export = (records, params) => {
        records = ArrayHelper.sortByValue(records, 'internal_id');

        let workbook = {
            Sheets: {
                'products': XLSX.utils.json_to_sheet(records.map(record => this.convertProductToExportRecord(record, params)))
            },
            SheetNames: ['products']
        };

        this.categories(workbook, params);
        this.additionaFields(workbook, params);

        let buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        FileSaver.saveAs(blob, 'products.xlsx');
    }

    static convertProductToExportRecord = (product, params) => {
        // Set general data
        let record = {
            id: product.internal_id,
            article_number: product.article_number,
            unit_price: product.unit_price,
            category: product.category,
            stock: product.stock,
            active: product.active ? 1 : 0,
            spotlight: product.spotlight ? 1 : 0,
        };

        if (!params.settings.use_spotlight) delete record.spotlight;
        if (!params.settings.use_categories) delete record.category;
        if (!params.settings.show_article_number) delete record.article_number;
        if (!params.settings.show_stock) delete record.stock;
        if (!params.settings.use_webshop) delete record.unit_price;

        params.website.languages.forEach(language => {
            let lng = language.language;

            record = {
                ...record, ...{
                    ['title_' + lng]: '',
                    ['content_' + lng]: ''
                }
            }

            if (params.settings.show_summary) {
                record['summary_' + lng] = '';
            }
            if (params.settings.use_product_tags) {
                record['tags_' + lng] = '';
            }


            let content = product.contents.filter(content => content.language === lng)[0];
            if (!content) return record;

            record['title_' + lng] = content?.title;
            record['content_' + lng] = JsonHelper.tryParse(content?.content)?.text;

            if ('summary_' + lng in record) {
                record['summary_' + lng] = content?.summary;
            }

            if ('tags_' + lng in record) {
                record['tags_' + lng] = content?.tags.length ? content.tags.join(',') : null;
            }

            if (params.additionalFields?.length) {
                params.additionalFields.forEach(field => {
                    let fieldContent = field.contents.find(content => content.language === lng);

                    if (field.has_prefix_choices) {
                        let prefixValue = content.additionalFieldValues[field.field_key + '__prepend'];
                        record['additional_field_' + field.field_key + '_prepend_' + lng + '|' + fieldContent.label + '_prefix'] = prefixValue;
                    }

                    let value = content.additionalFieldValues[field.field_key];
                    if (field.field_type === 'editor') value = JsonHelper.tryParse(value)?.text;
                    record['additional_field_' + field.field_key + '_' + lng + '|' + fieldContent.label] = value;

                    if (field.has_suffix_choices) {
                        let suffixValue = content.additionalFieldValues[field.field_key + '_append'];
                        record['additional_field_' + field.field_key + '_append_' + lng + '|' + fieldContent.label + '_suffix'] = suffixValue;
                    }
                })
            }
        });

        return record;
    }

    static categories = (workbook, params) => {
        if (!params.settings.use_categories) return workbook;

        let data = params.categories;
        data.push({ id: null, label: null });

        workbook.Sheets['categories'] = XLSX.utils.json_to_sheet(data);
        workbook.SheetNames.push('categories');

        return workbook;
    }

    static additionaFields = (workbook, params) => {
        if (!params.additionalFields?.length) return workbook;

        params.additionalFields.forEach(field => {
            if (field.field_type === 'select') {
                let content = field.contents.find(content => content.language === params.website.default_language);

                let data = [];

                field.options.forEach(option => {
                    let optionContent = option.contents.find(content => content.language === params.website.default_language);
                    data.push({ id: option.id, label: optionContent.label });
                });

                workbook.Sheets[content.label] = XLSX.utils.json_to_sheet(data);
                workbook.SheetNames.push(content.label);
            } else if (!!field.has_prefix_choices || !!field.has_suffix_choices) {
                let content = field.contents.find(content => content.language === params.website.default_language);

                let data = [];

                if (field.has_prefix_choices) {
                    content.prefix_choices.split(';').forEach(option => {
                        data.push({ voor: option });
                    });
                }

                if (field.has_suffix_choices) {
                    content.suffix_choices.split(';').forEach(option => {
                        data.push({ achter: option });
                    });
                }

                let sheetName = content.label.substring(0, 30);
                workbook.Sheets[sheetName] = XLSX.utils.json_to_sheet(data);
                workbook.SheetNames.push(sheetName);
            }
        });

        return workbook;
    }
}

export default ProductHelper;